import script from "./talentRecruitmentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./talentRecruitmentDialog.vue?vue&type=script&setup=true&lang=js"

import "./talentRecruitmentDialog.vue?vue&type=style&index=0&id=48a6684c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a6684c"]])

export default __exports__